export default __webpack_public_path__ + "static/19-e46b2c3b9d596503047ac063260fa070.png";